 var name_line = "";
  var second_lin= "";

$(document).on('keyup', '.popup_input_fields', function () {
      console.log($(this).val());
      var count = $(this).val().length;
      $('#text-overlay').text($(this).val());	
      var getcolor = $('[name="properties[Name Color]"]:checked').val();
      $('#text-overlay').css('color', getcolor);

    });

    
    /*-------Color----------*/
    
    $('[name="properties[Name Color]"]').on('click', function(){
      var getColor = $(this).val();
      $('#text-overlay').css('color', getColor);
    });
    
    /*-----------confirm Button----------*/
function allData(getmainvarid) {
  Shopify.queue = [];
  
  Shopify.queue.push({
                variantId: getmainvarid,
                quantity: 1
            });
    console.log(Shopify.queue);
    Shopify.addItem = function(id, qty, callback) {;
        var params = {
            quantity: qty,
            id: id
        };
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: params,
            success: function() {
                typeof callback == "function" && callback();
            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                console.log(XMLHttpRequest);
            }
        });
    }, Shopify.moveAlong = function() {
        if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            Shopify.addItem(request.variantId, request.quantity, Shopify.moveAlong);
            console.log(request.variantId + "item added to cart");
        }
    }, Shopify.moveAlong();
}

    $('.submit-personalization').on('click', function(){
    var getmainvarid = $(this).data("varientid");
    $(this).html("please wait...");
    allData(getmainvarid);
    setTimeout(function() {
       $(".buy-btn-with-qty_outer .shopify-product-form button").click();
    }, 6000)
    });
  /*-----------skip Button----------*/
    
    $('.skip-personalization').on('click', function(){ 
       $('.popup_input_fields').val('');
       $(".buy-btn-with-qty_outer .shopify-product-form button").click();
    });

